export var PaymentGatewayType;
(function (PaymentGatewayType) {
    PaymentGatewayType["manual"] = "manual_payment";
    PaymentGatewayType["thirdParty"] = "credit_card_third_party_provider";
    PaymentGatewayType["provider"] = "provider";
})(PaymentGatewayType || (PaymentGatewayType = {}));
